import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    // borderCollapse: "",
  },

  AssetImageDiv: {
    background: "#C4C4C4",
    borderRadius: "10px",
    marginRight: "20px",
  },
  AssetImage: {
    borderRadius: "8px",
  },
  DepartmentsDiv: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  listText: {
    color: theme.palette.text.primary,
    padding: "1px",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
    width: "17.5%",
  },
  listTextTwo: {
    color: theme.palette.text.primary,
    padding: "1px",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
    width: "15%",
    overflow: "hidden",
    borderCollapse: "collapse",
  },
  listTextCustom: {
    color: theme.palette.text.primary,
    padding: "10px 5px",
    minWidth: "150px",
    width: "auto",
    flex: "1 1 auto",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
  },
  assetsListModals: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  flexGap5: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "5px",
  },
}));

export default useStyles;